import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Faq(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M11.098 13.912l1.365-.4a.718.718 0 01-.236-.524c0-1.05 2.073-1.188 2.073-3.013C14.3 8.813 13.32 8 11.718 8 10.651 8 9.658 8.425 9 9.213l1.005 1.137c.385-.475.906-.775 1.527-.775.683 0 .98.325.98.713 0 .862-1.824 1.037-1.824 2.512 0 .438.149.825.41 1.112zm.595 2.688a1.02 1.02 0 001.006-1.013c0-.55-.46-1.012-1.006-1.012a1.02 1.02 0 00-1.005 1.013c0 .55.46 1.012 1.005 1.012z"
  }), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 4a8 8 0 016.865 12.11 1 1 0 00-.103.795l.775 2.653-2.724-.753a1 1 0 00-.772.101A8 8 0 1112 4zm10 8c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a9.96 9.96 0 004.675-1.158l4.058 1.122a1 1 0 001.227-1.244L20.8 16.75A9.96 9.96 0 0022 12z",
    clipRule: "evenodd"
  }));
}

export default Faq;